import * as React from 'react';
import * as CollapsibleCom from '@radix-ui/react-collapsible';
import { DropDownIcon } from '@features/ui/icons';
import { FC } from 'react';
import { TSectionCollapsible } from '@src/types';

type CollapsibleProps = React.ComponentProps<typeof CollapsibleCom.Root> & {
  item: TSectionCollapsible;
};
const Collapsible: FC<CollapsibleProps> = ({ item, ...props }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <CollapsibleCom.Root
      className="w-full"
      open={open}
      onOpenChange={setOpen}
      {...props}
    >
      <CollapsibleCom.Trigger asChild>
        <div className="flex items-center justify-between cursor-pointer items-center">
          <div className={'flex gap-x-5 pb-3 pt-4 items-center'}>
            <div className={'w-3.5 h-3.5 rounded-[28px] bg-white'} />
            <p className="text-sm font-medium">{item.title}</p>
          </div>
          <DropDownIcon />
        </div>
      </CollapsibleCom.Trigger>
      <CollapsibleCom.Content>
        <div className="mx-2.5 mb-3">
          <div
            dangerouslySetInnerHTML={{ __html: item.description ?? '' }}
            className={
              // We don't assume Tailwind typography plugin is enabled.
              // These utility selectors enforce spacing + list markers so
              // rendered HTML matches the editor preview closely.
              "text-sm leading-6 whitespace-normal [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:my-3 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:my-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:my-2 [&_p]:my-2 [&_strong]:font-semibold [&_a]:underline [&_a]:text-primary [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-2 [&_li]:my-1 [&_li::marker]:text-white"
            }
          />
        </div>
      </CollapsibleCom.Content>
    </CollapsibleCom.Root>
  );
};

export { Collapsible };
